import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ImportFileOutputData } from '#/graphql/types';
import SuccessModalBase from '../base/SuccessModalBase';

interface FindingSuccessModalProps {
  visible: boolean;
  onHiding: () => void;
  importResult: ImportFileOutputData | null;
}

const FindingSuccessModal: React.FC<FindingSuccessModalProps> = ({
  visible,
  onHiding,
  importResult,
}) => {
  const navigate = useNavigate();

  const redirectToFindingList = useCallback(() => {
    onHiding();
    navigate('/findings');
  }, [onHiding, navigate]);

  return (
    <SuccessModalBase
      visible={visible}
      onHiding={onHiding}
      importResult={importResult}
      entityRecordsLabelLower="finding records"
      entityPluralLabelLower="findings"
      onRedirect={redirectToFindingList}
    />
  );
};

export default FindingSuccessModal;
